import { FC, ReactNode } from 'react';
import { KioskFormsContextProps } from './kiosk-forms.context';
import KioskFormsMain from './kiosk-forms.main';

interface KioskFormsWrapperProps extends KioskFormsContextProps {
  children: ReactNode;
}

export const KioskFormsWrapper: FC<KioskFormsWrapperProps> = ({ children, ...contextProps }) => {
  return <KioskFormsMain {...contextProps}>{children}</KioskFormsMain>;
};
